<template>
  <div>
    <div tabindex="0" class="e-card" id="basic">
      <div class="e-card-title">SCC User Account</div>
      <div class="e-card-content">
        <div>
          <h4 class="title-color">Personal Information</h4>
        </div>
        <div class="e-card-separator"></div>
        <div class="form-row">
          <div style="width: 650px" class="form-row-input">
            <scc-input-validator
              :rules="[requiredRule]"
              :value="data.firstName"
              @validate="(v) => (this.isFirstNameValid = v)"
            >
              <ejs-textbox
                float-label-type="Always"
                placeholder="First Name"
                v-model="data.firstName"
              />
            </scc-input-validator>
          </div>
          <div style="width: 650px" class="form-row-input">
            <scc-input-validator
              :rules="[requiredRule]"
              :value="data.lastName"
              @validate="(v) => (this.isLastNameValid = v)"
            >
              <ejs-textbox
                float-label-type="Always"
                placeholder="Last Name"
                v-model="data.lastName"
              />
            </scc-input-validator>
          </div>
        </div>
        <div v-show="!isLoggedUser">
          <div>
            <h4 class="title-color">Web Login Information</h4>
          </div>
          <div class="e-card-separator"></div>
          <div class="form-row">
            <div style="width: 650px" class="form-row-input">
              <scc-input-validator
                :password="password"
                @validate="(v) => (this.isPasswordValid = v)"
              >
                <input-password
                  ref="refPassword"
                  v-model="password"
                  placeholder="New Password"
                />
              </scc-input-validator>
              <span v-show="this.isPasswordValid" class="e-success"
                ><span class="e-icons Selection"></span> Password is
                strong</span
              >
            </div>
            <div style="width: 650px" class="form-row-input">
              <scc-input-validator
                :value="confirmPassword"
                @validate="(v) => (this.isConfirmPassword = v)"
              >
                <input-password
                  ref="refPassword"
                  v-model="confirmPassword"
                  placeholder="Confirm Password"
                />
              </scc-input-validator>
              <span v-show="showConfirmPassword" class="e-error"
                ><span class="e-icons close"></span> Confirm password does not
                match with Password</span
              >
              <span v-show="showConfirmPasswordMatch" class="e-success"
                ><span class="e-icons Selection"></span> Password matched</span
              >
            </div>
          </div>
          <div class="form-row" style="padding: 0px 0px 15px 0px; margin: -5px">
            <ejs-checkbox
              label="Force User to Reset Password"
              v-model="isForcePasswordChange"
              labelPosition="Before"
            ></ejs-checkbox>
          </div>
          <div class="form-row">
            <span class="e-error">
              {{ passwordValidationMessage }}
            </span>
          </div>
        </div>
        <div v-show="!isUserProfile">
          <div>
            <h4 class="title-color">Permissions</h4>
          </div>
          <div class="e-card-separator"></div>
          <ul style="list-style-type: none; padding-inline-start: 0px">
            <li v-for="role in roles" :key="role.roleId">
              <div class="form-row">
                <div style="width: 150px" class="form-row-input">
                  <label>{{ role.roleName }}:</label>
                </div>
                <div style="font-size: 8px; font-style: italic">Inactive</div>
                <div style="width: 50px" class="form-row-input">
                  <ejs-switch
                    :id="role.roleId"
                    :checked="role.isRollChecked"
                    v-model="role.isRollChecked"
                  ></ejs-switch>
                </div>
                <span style="font-size: 8px; font-style: italic">Active</span>
              </div>
            </li>
          </ul>
          <span v-show="errorSelecteRole" class="e-success"
            >Please, select at least one role.</span
          >
          <div>
            <h4 class="title-color">Status</h4>
          </div>
          <div class="e-card-separator"></div>
          <div class="form-row">
            <div style="width: 150px" class="form-row-input">
              <label>Authorized:</label>
            </div>
            <div style="font-size: 8px; font-style: italic">Inactive</div>
            <div style="width: 50px" class="form-row-input">
              <ejs-switch
                id="status"
                v-model="isActive"
                ref="refStatus"
                :checked="isActive"
              ></ejs-switch>
            </div>
            <span style="font-size: 8px; font-style: italic">Active</span>
          </div>
          <div class="form-row">
            <div style="width: 150px" class="form-row-input">
              <label>Email:</label>
            </div>
            <div style="width: 250px" class="form-row-input">
              <ejs-textbox
                id="email"
                ref="refEmail"
                readonly="true"
                v-model="data.email"
              >
              </ejs-textbox>
            </div>
          </div>
        </div>
        <div class="align-center-bottom">
          <ejs-button
            type="button"
            cssClass="e-info margin-button"
            v-on:click.native="btnSaveUserInfo"
            >Save Contact Information</ejs-button
          >
          <ejs-button
            v-on:click.native="onCancelButtonClick"
            v-show="isLogedUserAdmin"
            cssClass="e-danger margin-button"
            >Cancel and Back to List</ejs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';

import {
  ButtonPlugin,
  CheckBoxPlugin,
  SwitchPlugin,
} from '@syncfusion/ej2-vue-buttons';
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import appConfig from '@/app.config';
import SccInputValidator from '../../../components/base/scc-input-validator.vue';
import inputPassword from '../../../components/base/input-password.vue';
import {
  GET_ROLES,
  GET_USER_PROFILES_BY_ID,
  REGISTER,
  USER_PROFILES,
  USER_IN_ROLES,
  GET_USER_DETAILS,
  RESET_PASSWORD,
  DEACTIVATE_USER,
  GET_PASSWORD_LOGS,
} from '../store';
import { FETCH_USER_BY_ID } from '../../auth/store';

Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(SwitchPlugin);
Vue.use(TextBoxPlugin);

export default {
  name: 'SccUserDetails',
  components: {
    SccInputValidator,
    inputPassword,
  },
  props: {
    userProfileId: String,
    isUserProfile: Boolean,
  },
  mounted() {
    this.getRoles();
    if (this.userProfileId !== '') {
      this.getUserById().then(() => {
        this.getUserDetail();
      });
    }
  },
  computed: {
    isLoggedUser() {
      return this.$store.getters.loggedUser
        ? this.$store.getters.loggedUser.id === this.userProfileId
        : false;
    },
    isLogedSccUser() {
      return this.$store.getters.loggedUser
        ? this.$store.getters.loggedUser.isSCCUser
        : '';
    },
    isLogedUserAdmin() {
      return (
        this.isCurrentUserInRole('admin')
        || this.isCurrentUserInRole('superadmin')
      );
    },
  },
  data() {
    return {
      userProfilesData: null,
      isConfirmPassword: false,
      showConfirmPassword: false,
      showConfirmPasswordMatch: false,
      // showPasswordStrong: false,
      isPasswordValid: false,
      isFirstNameValid: false,
      isLastNameValid: false,
      confirmPassword: null,
      password: null,
      profileId: null,
      isForcePasswordChange: true,
      isUpdate: false,
      isRoleSelected: false,
      errorSelecteRole: false,
      isActive: true,
      roles: [
        {
          roleId: null,
          roleName: null,
          isRollChecked: false,
        },
      ],
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      passwordValidationMessage: appConfig.passwordValidationMessage,      
      data: {
        firstName: null,
        lastName: null,
        email: '',
      },
      isRegisterSuccess: false,
      isUserProfileSuccess: true,
      isRoleSuccess: true,
      isUserDeactiveSuccess: true,
      userRole: [
        {
          id: null,
          userId: null,
          roleId: null,
          isChecked: false,
        },
      ],
      passwordLogs: [],
    };
  },
  created() {},
  watch: {
    confirmPassword(val) {
      if (
        val !== this.password
        && (this.password !== null || this.password !== '')
      ) {
        this.isConfirmPassword = false;
        this.showConfirmPassword = true;
        this.showConfirmPasswordMatch = false;
      } else if (val === '') {
        this.showConfirmPasswordMatch = false;
        this.showConfirmPassword = false;
        this.isConfirmPassword = false;
      } else {
        this.isConfirmPassword = true;
        this.showConfirmPassword = false;
        this.showConfirmPasswordMatch = true;
      }
    },
    password(val) {
      if (this.confirmPassword === null || this.confirmPassword === '') {
        this.showConfirmPasswordMatch = false;
        this.showConfirmPassword = false;
      } else if (val !== '' && val !== this.confirmPassword) {
        this.isConfirmPassword = false;
        this.showConfirmPassword = true;
        this.showConfirmPasswordMatch = false;
      } else if (val === null || val === '') {
        this.showConfirmPasswordMatch = false;
        this.showConfirmPassword = false;
        this.isConfirmPassword = false;
      } else {
        this.isConfirmPassword = true;
        this.showConfirmPassword = false;
        this.showConfirmPasswordMatch = true;
      }
    },
  },
  methods: {
    async getUserById() {
      try {
        const userId = this.userProfileId;
        if (userId !== null && userId !== 'null') {
          await this.$store.dispatch(FETCH_USER_BY_ID, { userId });
          this.userProfilesData = this.$store.getters.userById;
        }
      } catch (err) {
        console.error('user accounts err', err);
        if (err.message === 'Network Error') {
          this.$router.push({ name: 'NotFound' });
        } else {
          this.$router.push({ name: 'UnAuthorized' });
        }
      }
    },
    isCurrentUserInRole(roleName) {
      let roleIndex = -1;
      const currentUser = this.$store.getters.loggedUser;
      if (currentUser && currentUser.roles) {
        roleIndex = currentUser.roles.findIndex(
          (r) => r.roleName.toLowerCase() === roleName,
        );
      }
      return roleIndex >= 0;
    },
    async getPasswordLogsByUserId() {
      const userId = this.userProfileId; // this.$store.getters.loggedUser.id;
      if (userId) {
        await this.$store.dispatch(GET_PASSWORD_LOGS, { userId });
        this.passwordLogs = this.$store.getters.passwordLogs;
      }
      // console.log(this.passwordLogs);
    },
    permissionValidation() {
      for (let i = 0; i < this.roles.length; i += 1) {
        if (this.roles[i].isRollChecked) {
          this.isRoleSelected = true;
          break;
        } else this.isRoleSelected = false;
      }
      if (this.isRoleSelected) this.errorSelecteRole = false;
      else this.errorSelecteRole = true;

      return this.isRoleSelected;
    },
    validation() {
      this.password = this.password === null ? '' : this.password;
      this.data.firstName = this.data.firstName === null ? '' : this.data.firstName;
      this.data.lastName = this.data.lastName === null ? '' : this.data.lastName;
      this.confirmPassword = this.confirmPassword === null ? '' : this.confirmPassword;
    },
    onCancelButtonClick() {
      this.$router.push({ name: 'SCCUserList' });
    },
    async btnSaveUserInfo() {
      try {
        this.isUserDeactiveSuccess = false;
        this.isRoleSuccess = false;
        this.isUserDeactiveSuccess = false;
        if (
          this.isUpdate
          && this.isFirstNameValid
          && this.isLastNameValid
          && this.permissionValidation()
        ) {
          if (!this.password && !this.confirmPassword) {
            await this.userProfile().then(() => {
              this.isUserProfileSuccess = true;
            });
            await this.userInRoles().then(() => {
              this.isRoleSuccess = true;
            });
            if (!this.isActive) {
              await this.deactivateUser().then(() => {
                this.isUserDeactiveSuccess = true;
              });
            } else {
              this.isUserDeactiveSuccess = true;
            }
            if (
              this.isUserProfileSuccess
              && this.isRoleSuccess
              && this.isUserDeactiveSuccess
            ) {
              this.$parent.$parent.$parent.notificationToasts.push({
                title: 'Success!',
                content: 'User details save successfully.',
                cssClass: 'e-toast-success',
                timeOut: 5000,
              });
              this.$router.push({ name: 'SCCUserList' });
            }
          } else if (this.isConfirmPassword && this.isPasswordValid) {
            await this.register();
            await this.userProfile().then(() => {
              this.isUserProfileSuccess = true;
            });
            await this.userInRoles().then(() => {
              this.isRoleSuccess = true;
            });
            if (
              this.isRegisterSuccess
              && this.isUserProfileSuccess
              && this.isRoleSuccess
            ) {
              this.$parent.$parent.$parent.notificationToasts.push({
                title: 'Success!',
                content: 'User details save successfully.',
                cssClass: 'e-toast-success',
                timeOut: 5000,
              });
              this.$router.push('/scc-user-list');
            }
          } else {
            this.validation();
            this.$parent.$parent.$parent.notificationToasts.push({
              title: 'Error!',
              content: 'Please enter required field.',
              cssClass: 'e-toast-danger',
              timeOut: 5000,
            });
          }
        } else if (
          this.isConfirmPassword
          && this.isPasswordValid
          && this.isFirstNameValid
          && this.isLastNameValid
          && this.permissionValidation()
        ) {
          await this.register();
          await this.userProfile().then(() => {
            this.isUserProfileSuccess = true;
          });
          await this.userInRoles().then(() => {
            this.isRoleSuccess = true;
          });
          if (
            this.isRegisterSuccess
            && this.isUserProfileSuccess
            && this.isRoleSuccess
          ) {
            this.$parent.$parent.$parent.notificationToasts.push({
              title: 'Success!',
              content: 'User details save successfully.',
              cssClass: 'e-toast-success',
              timeOut: 5000,
            });
            this.$router.push('/scc-user-list');
          }
        } else {
          this.validation();
          this.$parent.$parent.$parent.notificationToasts.push({
            title: 'Error!',
            content: 'Please enter required field.',
            cssClass: 'e-toast-danger',
            timeOut: 5000,
          });
        }
      } catch (err) {
        this.$parent.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content:
            'Sorry, Something went wrong during saving information. Please try again later.',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }

      if (this.$parent.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$parent.$refs.notifierRef.show();
      }
    },
    async getRoles() {
      try {
        await this.$store.dispatch(GET_ROLES).then((resp) => {
          if (resp.status === 200) {
            this.roles = [];
            for (let j = 0; j < resp.data.length; j += 1) {
              this.roles.push({
                roleId: resp.data[j].roleId,
                roleName: resp.data[j].roleName,
                isRollChecked: false,
              });
            }
            // console.log('this.roles:', this.roles);
          }
        });
      } catch (err) {
        console.error(err);
      }
    },
    async getUserDetail() {
      try {
        if (this.userProfilesData !== null && this.userProfilesData !== '') {
          const { userName } = this.userProfilesData;
          await this.$store
            .dispatch(GET_USER_DETAILS, { userName })
            .then((resp) => {
              if (resp.status === 200) {
                // console.log('this.data1:', this.data);
                this.isUpdate = true;
                if (resp.data[0].userProfile !== null) {
                  this.data.firstName = resp.data[0].userProfile.firstName;
                  this.data.lastName = resp.data[0].userProfile.lastName;
                }
                this.data.email = resp.data[0].userName;
                this.isActive = resp.data[0].memberShip.isApproved;
                if (resp.data[0].userProfile !== null) {
                  this.profileId = resp.data[0].userProfile.id;
                } else {
                  this.profileId = null;
                }
                const usersRoles = resp.data[0].usersInRoles;
                for (let i = 0; i < this.roles.length; i += 1) {
                  for (let j = 0; j < usersRoles.length; j += 1) {
                    if (this.roles[i].roleId === usersRoles[j].roleId) {
                      this.roles[i].isRollChecked = true;
                    }
                  }
                }
              }
            });
        }
      } catch (err) {
        console.error(err);
      }
    },
    async getUserProfilesById() {
      try {
        const userId = this.userProfileId;
        await this.$store.dispatch(GET_USER_PROFILES_BY_ID, { userId });
        this.data = { ...this.data, ...this.$store.getters.userProfilesbyID };
        if (this.$store.getters.userProfilesbyID !== null) {
          this.profileId = this.$store.getters.userProfilesbyID.id;
        } else {
          this.profileId = null;
        }
      } catch (err) {
        console.error(err);
      }
    },

    async deactivateUser() {
      try {
        this.userName = this.userProfilesData.userName;
        const { userName } = this;
        await this.$store
          .dispatch(DEACTIVATE_USER, { userName })
          .then((resp) => {
            if (resp.status === 200) {
              this.$parent.$parent.$parent.notificationToasts.push({
                title: 'Success!',
                content:
                  'User successfully deactivated. Please check inactive user tab.',
                cssClass: 'e-toast-success',
                timeOut: 5000,
              });
            }
          });
      } catch (err) {
        this.isUserDeactiveSuccess = false;
        this.$parent.$parent.$parent.notificationToasts.push({
          title: 'Error!',
          content: 'Sorry, Something went wrong. Please try again later.',
          cssClass: 'e-toast-danger',
          timeOut: 5000,
        });
      }

      if (this.$parent.$parent.$parent.notificationToasts.length > 0) {
        this.$parent.$parent.$parent.$refs.notifierRef.show();
      }
    },
    async register() {
      try {
        this.username = this.userProfilesData.userName;
        this.email = this.userProfilesData.userName;
        if (this.profileId !== null) {
          // profileId is id from userprofile table
          const userId = this.userProfileId;
          const { password } = this;
          await this.$store.dispatch(RESET_PASSWORD, {
            userId,
            password,
            forcePasswordChange: this.isForcePasswordChange,
          });
          this.isRegisterSuccess = true;
        } else {
          const { username, email, password } = this;
          await this.$store.dispatch(REGISTER, {
            username,
            email,
            password,
            forcePasswordChange: this.isForcePasswordChange,
            isSCCUser: true,
          });
          this.isRegisterSuccess = true;
        }
      } catch (err) {
        console.error(err);
      }
    },
    async userProfile() {
      try {
        if (this.profileId !== null) {
          const data = Object.assign(this.data, {
            id: this.profileId,
            userFullName: `${this.data.firstName} ${this.data.lastName}`,
          });
          await this.$store.dispatch(USER_PROFILES, data);
        } else {
          const data = Object.assign(this.data, {
            userId: this.userProfileId,
            userFullName: `${this.data.firstName} ${this.data.lastName}`,
          });
          await this.$store.dispatch(USER_PROFILES, data);
        }
      } catch (err) {
        console.error(err);
        this.isUserProfileSuccess = false;
      }
    },
    async userInRoles() {
      try {
        this.userRole = [];
        for (let k = 0; k < this.roles.length; k += 1) {
          const selectedRoles = {};
          if (this.roles[k].isRollChecked) {
            selectedRoles.userId = this.userProfileId;
            selectedRoles.roleId = this.roles[k].roleId;
            this.userRole.push(selectedRoles);
          }
        }
        await this.$store.dispatch(USER_IN_ROLES, this.userRole);
      } catch (err) {
        console.error(err.message);
        this.isRoleSuccess = false;
      }
    },
  },
};
</script>
<style>
@import "../../../assets/styles/eservices-base.css";

#loader {
  color: #008cff;
  height: 40px;
  left: 45%;
  position: absolute;
  top: 45%;
  width: 30%;
}
.container_userinfo {
  min-width: 80%;
  margin: 0 10px;
}
</style>
